import { sfg20DateFormat } from "lib/sfg20-date-format"
import { assetAndTaskDateFields } from "../regime-display/assetAndTaskDateFields"
import { DATE_FORMATS } from "lib/@constants/date-format"

export const EXCEL_ERROR_PLACEHOLDER = "Excel Error"

export function convertCellToTextOrDate(row, column, mappings = {}, withErrors = false) {
    // handle cell content that is a formula or a date
    let cellContent = findCellContent(row, column)

    if (cellContent instanceof Date) {
        cellContent = cellContent.toLocaleString("en-GB")
    }

    for (const field in mappings) {
        if (assetAndTaskDateFields.includes(field) && mappings[field]?.column === column) {
            let dateCell
            try {
                dateCell = findCellContent(row, mappings[field].column)
                if (dateCell == null || dateCell === "" || (typeof dateCell === "number" && dateCell === 0)) {
                    cellContent = ""
                } else {
                    const dateCellRaw = row.getCell(mappings[field].column)
                    if (typeof dateCell === "number" && !isDateFormatted(dateCellRaw)) {
                        throw new Error("Date is not valid")
                    }
                    cellContent = sfg20DateFormat(dateCell, DATE_FORMATS.medium)
                }
            } catch (e) {
                if (withErrors) throw e
                return dateCell
            }
        }
    }

    return cellContent
}

function findCellContent(row, column) {
    const cell = row.getCell(column)
    return normalizeExcelCell(cell)
}

export function normalizeExcelCell(cell) {
    if (!cell) return null

    const normalizedValue = normalizeExcelCellValue(cell.value)
    if (normalizedValue !== null && normalizedValue !== undefined) {
        return normalizedValue
    }

    const rawValue = cell.value
    if (rawValue && typeof rawValue === "object" && ("formula" in rawValue || "sharedFormula" in rawValue)) {
        const fallback = cell?._value?.model?.value ?? cell?._value?.model?.result
        if (fallback !== undefined) return normalizeExcelCellValue(fallback)
    }

    return normalizedValue
}

export function normalizeExcelCellValue(value) {
    if (value === null || value === undefined) return value
    if (value instanceof Date) return value

    const primitive = typeof value
    if (primitive === "string" || primitive === "number" || primitive === "boolean") return value

    if (value && typeof value === "object" && Array.isArray(value.richText)) {
        return value.richText.map((part) => (part && typeof part.text === "string" ? part.text : "")).join("")
    }

    if (value && typeof value === "object" && typeof value.error === "string") {
        return `${EXCEL_ERROR_PLACEHOLDER}: ${value.error}`
    }

    if (value && typeof value === "object" && "result" in value && value.result !== undefined) {
        return normalizeExcelCellValue(value.result)
    }

    // ExcelJS formula objects can exist without an evaluated result if the sheet was not recalculated.
    // Preserve prior behaviour by treating those cells as empty/raw value instead of serialized object text.
    if (value && typeof value === "object" && ("formula" in value || "sharedFormula" in value)) {
        if ("value" in value) return normalizeExcelCellValue(value.value)
        if ("result" in value) return normalizeExcelCellValue(value.result)
        return null
    }

    if (value && typeof value === "object" && typeof value.text === "string") {
        return value.text
    }

    try {
        return JSON.stringify(value)
    } catch {
        try {
            return String(value)
        } catch {
            return ""
        }
    }
}

function isDateFormatted(cell) {
    const format = `${cell?.style?.numFmt ?? cell?.numFmt ?? ""} `.toLowerCase()
    return /[dmy]/.test(format)
}
